import { Component } from 'react';
import { Helmet } from 'react-helmet';
import goodalipi from 'src/plugins/goodalipi';
import SearchRecords from './SearchRecords';
import {
    Box,
    Container,
    Grid,
    Card,
    CardContent,
    CircularProgress,
    Typography,
} from '@mui/material';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import VerticalBarGraph from 'src/components/pages/ahc/ahcDashboard/VerticalBarGraph';
import RequestChart from '../vaccination/dashboard/RequestChart';
import StackedBarGraph from './StackedBarGraph';


let today = new Date();
let startOfYearDate = new Date(today.getFullYear(), 0, 1);
const daysToPreFetch = Math.floor((today.getTime() - startOfYearDate.getTime()) / (1000 * 60 * 60 * 24));

class MedicineUtilization extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: {
                dateRange: [],
                campLocation: [],
                providerName: [],
                campType: [],
                benf: [],
                payment: '',
                entityRequested: ''
            },
            filterOptions: {
                campLocationList: [],
                providerNameList: [],
                campTypeList: [],
                paymetnList: [],
                benfList: [],
                entityRequested: goodalipi.get('globalHRgroup') ? goodalipi.get('globalHRgroup') : []
            },
            momUniqueUserCount: {},
            momDeliveries: {},
            cashlessAmountForDeliveredOrders: {},
            locationWiseDeliveries: null,
            platformWiseLogins: {},
            daysToPreFetch: daysToPreFetch
        }
    }

    componentDidMount = () => {
        this.getMOMUniqueUserCount(this.state.daysToPreFetch);
        // this.getCashlessAmountForDeliveredOrders(this.state.daysToPreFetch);
        this.getMOMDeliveries(this.state.daysToPreFetch);
        this.getLocationWiseDeliveries(this.state.daysToPreFetch);
        this.getPlafromWiseLogins(this.state.daysToPreFetch);
    }

    applyFilters() {
        const payload = {};
        if (this.state.filter.campLocation.length)
            payload.campLocation = this.state.filter.campLocation;
        if (this.state.filter.campType.length)
            payload.campType = this.state.filter.campType;
        if (this.state.filter.providerName.length)
            payload.providerName = this.state.filter.providerName;
        if (this.state.filter.payment) payload.payment = this.state.filter.payment;
        if (this.state.filter.benf.length) payload.benf = this.state.filter.benf;
        if (this.state.filter.dateRange.length == 2) {
            let startDate = new Date(this.state.filter.dateRange[0]);
            let endDate = new Date(this.state.filter.dateRange[1]);
            payload['apptDateBegin'] =
                startDate.getFullYear() +
                '-' +
                ('0' + (startDate.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + startDate.getDate()).slice(-2);
            payload['apptDateEnd'] =
                endDate.getFullYear() +
                '-' +
                ('0' + (endDate.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + endDate.getDate()).slice(-2);
        }
        if (this.state.filter.entityRequested) {
            payload.globalHR = true;
            payload.entityRequested = this.state.filter.entityRequested;
        }

        this.getMOMUniqueUserCount(this.state.daysToPreFetch, { ...payload })
        this.getMOMDeliveries(this.state.daysToPreFetch, { ...payload })
        // this.getCashlessAmountForDeliveredOrders(this.state.daysToPreFetch, { ...payload })
        this.getLocationWiseDeliveries(this.state.daysToPreFetch, { ...payload })
        this.getPlafromWiseLogins(this.state.daysToPreFetch, { ...payload });
    }

    getMOMUniqueUserCount = async (daysToPreFetch, payload = {}) => {
        payload = this.setInitialPayload(daysToPreFetch, payload);

        this.setState({ momUniqueUserCount: {} })
        _axios.post('/pharma/momUniqueUsers', payload, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response?.data?.isSuccess) {
                let formattedData = response?.data?.result?.reduce((acc, curr) => {
                    let month = curr?.R_createdon ? moment(curr.R_createdon)?.format("MMM YY") : null;
                    acc.labels.push(month);
                    acc.data.push(curr["Distinct Users"]);
                    return acc;
                },
                    {
                        labels: [],
                        data: []
                    }
                );

                this.setState({
                    momUniqueUserCount: {
                        labels: formattedData?.labels
                            ? formattedData.labels
                            : [],
                        datasets: [
                            {
                                data: formattedData?.data
                                    ? formattedData.data
                                    : [],
                                backgroundColor: '#1778f2',
                                barPercentage: 0.5,
                                maxBarThickness: 15,
                                minBarLength: 3
                            }
                        ]
                    }
                })
            }
            else
                throw new Error(response.errorMessage)
        }).catch(err => {
            console.log(err.message);
        })
    }

    getMOMDeliveries = async (daysToPreFetch, payload = {}) => {
        payload = this.setInitialPayload(daysToPreFetch, payload);

        this.setState({ momDeliveries: {} })
        _axios.post('/pharma/momDeliveredOrders', payload, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response?.data?.isSuccess) {
                let formattedData = response?.data?.result?.reduce((acc, curr) => {
                    let month = curr?.r_modifiedon ? moment(curr.r_modifiedon)?.format("MMM YY") : null;
                    acc.labels.push(month);
                    acc.data.push(curr["Order Count"]);
                    return acc;
                },
                    {
                        labels: [],
                        data: []
                    }
                );

                this.setState({
                    momDeliveries: {
                        labels: formattedData?.labels
                            ? formattedData.labels
                            : [],
                        datasets: [
                            {
                                data: formattedData?.data
                                    ? formattedData.data
                                    : [],
                                backgroundColor: '#1778f2',
                                barPercentage: 0.5,
                                maxBarThickness: 15,
                                minBarLength: 3
                            }
                        ]
                    }
                })
            }
            else
                throw new Error(response.errorMessage)
        }).catch(err => {
            console.log(err.message);
        })
    }

    getCashlessAmountForDeliveredOrders = async (daysToPreFetch, payload = {}) => {
        payload = this.setInitialPayload(daysToPreFetch, payload);

        this.setState({ cashlessAmountForDeliveredOrders: {} })
        _axios.post('/pharma/cashlessAmount', payload, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response?.data?.isSuccess) {
                let formattedData = response?.data?.result?.reduce((acc, curr) => {
                    acc.labels.push(curr.date_);
                    acc.data.push(curr.corpwalletamountgmv);
                    return acc;
                },
                    {
                        labels: [],
                        data: []
                    }
                );

                this.setState({
                    cashlessAmountForDeliveredOrders: {
                        labels: formattedData?.labels
                            ? formattedData.labels
                            : [],
                        datasets: [
                            {
                                data: formattedData?.data
                                    ? formattedData.data
                                    : [],
                                backgroundColor: '#1778f2',
                                barPercentage: 0.5,
                                maxBarThickness: 15,
                                minBarLength: 3
                            }
                        ]
                    }
                })
            }
            else
                throw new Error(response.errorMessage)
        }).catch(err => {
            console.log(err.message);
        })
    }

    getLocationWiseDeliveries = async (daysToPreFetch, payload = {}) => {
        payload = this.setInitialPayload(daysToPreFetch, payload);

        this.setState({ locationWiseDeliveries: null })
        _axios.post('/pharma/locationWiseOrders', payload, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response?.data?.isSuccess) {
                let formattedData = response?.data?.result?.reduce((acc, curr) => {
                    acc.labels.push(curr?.Location);
                    acc.data.push(curr["Order Count"]);
                    return acc;
                },
                    {
                        labels: [],
                        data: []
                    }
                );

                this.setState({
                    locationWiseDeliveries: {
                        labels: formattedData?.labels
                            ? formattedData.labels
                            : [],
                        datasets: [
                            {
                                label: "Deliveries",
                                data: formattedData?.data
                                    ? formattedData.data
                                    : [],
                                backgroundColor: '#1778f2',
                                barPercentage: 0.5,
                                maxBarThickness: 15,
                                minBarLength: 3
                            }
                        ]
                    }
                })
            }
            else
                throw new Error(response.errorMessage)
        }).catch(err => {
            console.log(err.message);
        })
    }

    getPlafromWiseLogins = async (daysToPreFetch, payload = {}) => {
        payload = this.setInitialPayload(daysToPreFetch, payload);

        this.setState({ platformWiseLogins: {} })
        _axios.post('/pharma/platformWise', payload, {
            ignoreLoading: true,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response?.data?.isSuccess) {
                let formattedData = response?.data?.result?.reduce((acc, curr, index) => {
                    let month = curr?.r_createdon ? moment(curr.r_createdon)?.format("MMM YY") : null;
                    if (!acc.labels.find(x => x == month)) {
                        acc.labels.push(month);

                        let webValue = response?.data?.result?.find((x, idx) => x.r_createdon == curr.r_createdon && x.BookingSource == 'web');
                        if (webValue && Object.keys(webValue).length > 0)
                            acc.data[0].push(webValue['Order Count']);
                        else
                            acc.data[0].push(0);

                        let iosValue = response?.data?.result?.find((x, idx) => x.r_createdon == curr.r_createdon && x.BookingSource == 'iOSMB');
                        if (iosValue && Object.keys(iosValue).length > 0)
                            acc.data[1].push(iosValue['Order Count']);
                        else
                            acc.data[1].push(0);

                        let androidValue = response?.data?.result?.find((x, idx) => x.r_createdon == curr.r_createdon && x.BookingSource == 'Android');
                        if (androidValue && Object.keys(androidValue).length > 0)
                            acc.data[2].push(androidValue['Order Count']);
                        else
                            acc.data[2].push(0);
                    }
                    return acc;
                },
                    {
                        labels: [],
                        data: [[], [], []]
                    }
                );

                this.setState({
                    platformWiseLogins: {
                        labels: formattedData?.labels
                            ? formattedData.labels
                            : [],
                        datasets: [
                            {
                                label: "Web",
                                data: formattedData?.data.length > 0
                                    ? formattedData.data[0]
                                    : [],
                                backgroundColor: '#1778f2',
                                barPercentage: 0.5,
                                maxBarThickness: 15,
                                minBarLength: 5
                            },
                            {
                                label: "IOS",
                                data: formattedData?.data.length > 1
                                    ? formattedData.data[1]
                                    : [],
                                backgroundColor: 'red',
                                barPercentage: 0.5,
                                maxBarThickness: 15,
                                minBarLength: 5
                            },
                            {
                                label: "Android",
                                data: formattedData?.data.length > 2
                                    ? formattedData.data[2]
                                    : [],
                                backgroundColor: 'yellow',
                                barPercentage: 0.5,
                                maxBarThickness: 15,
                                minBarLength: 5
                            }
                        ]
                    }
                })
            }
            else
                throw new Error(response.errorMessage)
        }).catch(err => {
            console.log(err.message);
        })
    }

    setInitialPayload = (till, payload) => {
        let lastSelectedDays = {};
        if (
            moment(payload.apptDateEnd).diff(moment(payload.apptDateBegin), 'days') <
            14 &&
            payload.apptDateEnd
        ) {
            till = moment(payload.apptDateEnd).diff(
                moment(payload.apptDateBegin),
                'days'
            );
        }
        _.forEach(
            [...Array(till).keys()].reverse().map((value) => value + 1),
            (days) => {
                lastSelectedDays[
                    moment(payload.apptDateEnd).subtract(days, 'd').format('YYYY-MM-DD')
                ] = {};
            }
        );
        payload.statType = 'day';
        if (!payload.apptDateEnd) {
            payload.apptDateBegin = moment().subtract(till, 'd').format('YYYY-MM-DD');
            payload.apptDateEnd = moment().subtract(0, 'd').format('YYYY-MM-DD');
        }
        return payload;
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Medicine | Utilization</title>
                </Helmet>
                <Box
                    sx={{
                        backgroundColor: 'background.default',
                        minHeight: '100%',
                        py: 2
                    }}
                >
                    <Container maxWidth={false}>
                        <SearchRecords
                            filterOptions={this.state.filterOptions}
                            filter={this.state.filter}
                            setFilters={(value) => this.setState({ filter: value })}
                            onRefresh={() => this.applyFilters()}
                        />

                        <Grid container sx={{ my: 3 }}>
                            <Card
                                sx={{
                                    width: '48%',
                                    borderRadius: 4,
                                    m: 1,
                                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                                }}
                            >
                                <CardContent>
                                    <Grid item xs={12} sx={{ px: 1 }}>
                                        <Typography variant="h5" sx={{ py: 2 }}>Total Orders Delivered (Monthly)</Typography>
                                        <PerfectScrollbar>
                                            <Box
                                                sx={{
                                                    height: '200px',
                                                    width: '100%'
                                                }}
                                                className="display-center"
                                            >
                                                {!Object.keys(this.state.momDeliveries).length ? (
                                                    <CircularProgress size={30} />
                                                ) : (
                                                    <VerticalBarGraph data={this.state.momDeliveries} />
                                                )}
                                            </Box>
                                        </PerfectScrollbar>
                                    </Grid>
                                </CardContent>
                            </Card>

                            <Card
                                sx={{
                                    width: '48%',
                                    borderRadius: 4,
                                    m: 1,
                                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                                }}
                            >
                                <CardContent>
                                    <Grid item xs sx={{ px: 1 }}>
                                        <Typography variant="h5" sx={{ py: 2 }}>Active User Count (Monthly)</Typography>
                                        <PerfectScrollbar>
                                            <Box
                                                sx={{
                                                    height: '200px',
                                                    width: '100%'
                                                }}
                                                className="display-center"
                                            >
                                                {!Object.keys(this.state.momUniqueUserCount).length ? (
                                                    <CircularProgress size={30} />
                                                ) : (
                                                    <VerticalBarGraph data={this.state.momUniqueUserCount} />
                                                )}
                                            </Box>
                                        </PerfectScrollbar>
                                    </Grid>
                                </CardContent>
                            </Card>

                            {/* <Card
                                sx={{
                                    width: '48%',
                                    borderRadius: 4,
                                    m: 1,
                                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                                }}
                            >
                                <CardContent>
                                    <Grid item xs={12} sx={{ px: 1 }}>
                                        <Typography variant="h5" sx={{ py: 2 }}>Cashless Amount for Delivered Orders (Monthly)</Typography>
                                        <PerfectScrollbar>
                                            <Box
                                                sx={{
                                                    height: '200px',
                                                    width: '100%'
                                                }}
                                                className="display-center"
                                            >
                                                {!Object.keys(this.state.cashlessAmountForDeliveredOrders).length ? (
                                                    <CircularProgress size={30} />
                                                ) : (
                                                    <VerticalBarGraph data={this.state.cashlessAmountForDeliveredOrders} />
                                                )}
                                            </Box>
                                        </PerfectScrollbar>
                                    </Grid>
                                </CardContent>
                            </Card> */}

                            <Card
                                sx={{
                                    width: '48%',
                                    borderRadius: 4,
                                    m: 1,
                                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                                }}
                            >
                                <CardContent>
                                    <Grid item xs={12} sx={{ px: 1 }}>
                                        <Typography variant="h5" sx={{ py: 2 }}>No. of Users Placing Orders by Platform (Monthly)</Typography>
                                        <PerfectScrollbar>
                                            <Box
                                                sx={{
                                                    height: '200px',
                                                    width: '100%'
                                                }}
                                                className="display-center"
                                            >
                                                {!Object.keys(this.state.platformWiseLogins).length ? (
                                                    <CircularProgress size={30} />
                                                ) : (
                                                    <StackedBarGraph data={this.state.platformWiseLogins} />
                                                )}
                                            </Box>
                                        </PerfectScrollbar>
                                    </Grid>
                                </CardContent>
                            </Card>

                        </Grid>
                        <Grid>
                            <Card
                                sx={{
                                    width: '100%',
                                    borderRadius: 4,
                                    m: 1,
                                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                                }}
                            >
                                <CardContent>
                                    <Grid item xs={12} sx={{ px: 1 }}>
                                        <Typography variant="h5" sx={{ py: 2 }}>Orders Delivered by Location (Monthly)</Typography>
                                        <RequestChart
                                            refreshBarChart={(till) => {
                                                this.refreshChartView(till);
                                            }}
                                            data={this.state.locationWiseDeliveries}
                                            isHeaderRequired={false}
                                        />
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Container>
                </Box>
            </>
        );
    }
}


export default MedicineUtilization;